import React , {useState, useEffect}from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddBaseDiscountModel = ({ isShowing, hide , addDiscount}) => {
const [discount, handlediscount] = useState(0);
const [totalSecondagesFrom, handleTotalSecondagesFrom] = useState(0);
const [totalSecondagesTo, handleTotalSecondagesTo] = useState(0);
const [count, handleCount] = useState(1);
const [disable, handleDisable] =useState("disableButton");
  useEffect(() => {
    
  })

  const closePopup = () => {
    hide();
    handleCount(1);
  }

  const checkFields = () => {
    if(totalSecondagesFrom>=0 && totalSecondagesTo>0 && discount>0){
      handleDisable("");
    }
  }

  const handleRangeFrom = (e) => {
    console.log(e.target.value);
    handleTotalSecondagesFrom(e.target.value);
    checkFields();
  }

  const handleRangeTo = (e) => {
    console.log(e.target.value);
    handleTotalSecondagesTo(e.target.value);
    checkFields();
  }

  const handleRangeDiscount = (e) => {
    console.log(e.target.value);
    handlediscount(e.target.value);
    checkFields();
  }

  const handleDiscountAndRange = (e) =>{
    e.preventDefault();
    if(Number(totalSecondagesFrom)>  Number(totalSecondagesTo)){
      toast.error(`Range from should be lesser than Range to `, {
        position:toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar:true,
        toastId:"1"
     });
     return
    }
    
    if(discount ===""){
      toast.error('Please enter valid number for discount', {
        position:toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar:true,
        toastId:"3"
     });
     return
    }
   
   
    handleCount(1);
    const params ={
      discount: Number(discount), 
      totalSecondagesFrom: Number(totalSecondagesFrom),
      totalSecondagesTo: Number(totalSecondagesTo)
     }
     addDiscount(params)
  }

return(
  isShowing?  <div>
  <div className="modal-overlay">
    <div className="modal-wrapper thankyou-popup" aria-modal aria-hidden tabIndex={-1} role="dialog">
      <div className="modal">
        <div className="modal-head-cross rate-modal">
          <button type="button" className="modal-close-button" onClick={closePopup}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
       
        <div className="editNonFct-header modal-header" >
          <h4 className="popup-head rqst-head fct-head modal-title">Add Base Discount</h4></div>
        <div className="editNonFct-modal modal-body">
          <div className="bg-white">
            <form className="form-group">
              <div className="popupCampaign-container">
               
                <div className="campaign-input master-inputs nonFct">
                <div className="input-tag signup-tag clearfix fct-input">
                    <label className="static-value">Range From</label>
                    <input name="stationName" type="number" className="form-control"  onChange={handleRangeFrom}  />
                  </div>
                  </div>

                  <div className="campaign-input master-inputs nonFct">
                  <div className="input-tag signup-tag clearfix fct-input">
                    <label className="static-value">Range To</label>
                    <input name="stationName" type="number" className="form-control" onChange={handleRangeTo}  />
                  </div>
                  </div>

                <div className="campaign-input master-inputs nonFct">
                  <div className="input-tag signup-tag clearfix fct-input">
                    <label className="static-value">Discount</label>
                    <input name="stockUpdate" type="number" className="form-control"  onChange={handleRangeDiscount} />
                  </div>
                </div>
                <div className="create-camp nonfct-submit">
                  <button onClick={handleDiscountAndRange}>SAVE CHANGES</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
        </div>
        {/* <div className="modal-footer cost_button">
         <button className="cncl">Cancel</button>
         <button className="procd">Ok</button>
        </div> */}
      </div>
    </div>
    <ToastContainer />
</div>:null
)
}

export default AddBaseDiscountModel;


// WEBPACK FOOTER //
// ./web/components/admin/common/addBaseDiscountModel.js